import { render } from "./AddBookView.vue?vue&type=template&id=99f986b8"
import script from "./AddBookView.vue?vue&type=script&lang=js"
export * from "./AddBookView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__